/**
 * Single fetch for Naturals salon skin analysis settings
 * (capture + concerns/conditions + product/service suggestion flags).
 */
import { SESSION_APP_DATA_BASE } from '../config/sessionAppData';
import { fetchWithTimeout } from './fetchWithTimeout';
import { getFranchiseOrganizationId } from '../../shared/franchiseFlowAuth';

const cache = new Map();
const inflight = new Map();
const CACHE_TTL_MS = 8000;

function cacheKey(token) {
  const org = getFranchiseOrganizationId() || '';
  return `${String(token || '').trim()}::${org}`;
}

export function skinAnalysisBundleUrl(token) {
  const qs = new URLSearchParams({ _: String(Date.now()) });
  const org = getFranchiseOrganizationId();
  if (org) qs.set('organization_id', String(org));
  return `${SESSION_APP_DATA_BASE}/${encodeURIComponent(token)}/skin-analysis?${qs.toString()}`;
}

export async function fetchSkinAnalysisBundle(token, { timeoutMs = 20000, force = false } = {}) {
  const key = cacheKey(token);
  if (!String(token || '').trim()) return null;
  const hit = cache.get(key);
  if (!force && hit && Date.now() - hit.at < CACHE_TTL_MS) return hit.data;
  if (!force && inflight.has(key)) return inflight.get(key);

  const promise = fetchWithTimeout(skinAnalysisBundleUrl(token), { timeoutMs })
    .then((res) => {
      if (!res.ok) throw new Error('skin-analysis unavailable');
      return res.json();
    })
    .then((data) => {
      const payload = data && typeof data === 'object' ? data : {};
      cache.set(key, { data: payload, at: Date.now() });
      inflight.delete(key);
      return payload;
    })
    .catch((err) => {
      inflight.delete(key);
      throw err;
    });

  inflight.set(key, promise);
  return promise;
}

export function clearSkinAnalysisBundleCache(token) {
  if (token == null) {
    cache.clear();
    inflight.clear();
    return;
  }
  const prefix = `${String(token).trim()}::`;
  for (const map of [cache, inflight]) {
    for (const k of [...map.keys()]) {
      if (k === String(token).trim() || String(k).startsWith(prefix)) map.delete(k);
    }
  }
}
